module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/_babel-loader@7.0.0@babel-loader/lib/index.js!./Home.jsx"));
	});
}


// WEBPACK FOOTER //
// ./src/containers/Welcome/Home.jsx